<template>
    <div v-if="visible">
        <div class="deemed"></div>
        <div class="layer-pop">
            <div class="layer-pop-wrap">
                <h2 class="txt-right"><img src="@/assets/img/layer-close.svg" alt="닫기" @click="close()"></h2>
                <div class="coach-youtube">
                    <h3>
                        {{recom.contentTitle}}
                    </h3>
                    <div class="clear" >
                        <div class="float-left w-50 ">
                            <h4>{{recom.recomDate}}</h4>
                        </div>
                        <div class="float-right w-50">
                            <span class="txt-red mr-10 pointer" @click="deleteContent()">삭제</span>
                            <span class="txt-blue pointer mr-10" @click="retakeVideo()">재발송</span>
                            <span class="txt-blue pointer"  @click="videoModify()">수정</span>
                            
                        </div>
                    </div>
                    <div v-if="isVideoLoading" class="youtube-wrap">
                        <iframe :src="videoUrl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <p>
                        {{recom.contentReasonsRecommendation}}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name:"recomVideoPop",
        props: {
            visible: {
                type: Boolean,
                require: true,
                default: false
            },
            recom:{
                type:Object,
                default:()=>{
                    return{
                        contentTitle:"",
                        contentReasonsRecommendation:"",
                        contentVideoUrl:"",
                        recomDate:"",
                        contentIdx:""
                    }
                }
            }
            
        },
        data: () => ({
            videoUrl:"",
            isVideoLoading :false
        }),
        watch:{
            visible: function (newVal) {
                if (newVal == true) {
                    this.visible = true;
                    // console.log(this.recom);
                    this.setVideoUrl();
                }else{
                    this.visible = false;
                }
            }
        },
        mounted() {
        },
        methods: {
            retakeVideo(){
                this.$router.push({name:"video_write",params:{isRetake:this.recom.contentIdx}});
            },
            videoModify(){
                this.$router.push({name:"video_modify",params:{contentIdx:this.recom.contentIdx}})
            },
            deleteContent(){
                if(confirm("해당 추천 영상을 삭제 하시겠습니까? 삭제 시 복구할 수 없습니다.")){
                    // console.log(this.recom)
                    let params = {
                        contentIdxList : []
                    }
                    params.contentIdxList.push(this.recom.contentIdx);
                    this.axios.delete("/content",{data:params}).then((res)=>{
                        if(res.data.success){
                            this.close();
                        }
                    }).catch((err)=>{
                        console.log(err);
                    });
                }
            },
            setVideoUrl(){
                let replaceUrl = this.recom.contentVideoUrl;
                let finUrl = '';
                replaceUrl = replaceUrl.replace("https://m.youtube.com/watch?v=", '');
                replaceUrl = replaceUrl.replace("https://youtu.be/", '');
                replaceUrl = replaceUrl.replace("https://www.youtube.com/embed/", '');
                replaceUrl = replaceUrl.replace("https://www.youtube.com/watch?v=", '');
                finUrl = replaceUrl.split('&')[0];
                // console.log(finUrl);
                this.videoUrl = `https://www.youtube.com/embed/${finUrl}`;
                console.log(this.videoUrl);
                this.isVideoLoading = true;
            },
            close(){
                this.$emit("close", false);
            },
        }
    }
</script>